import { User } from 'src/apis'
import Vue from 'vue'
// import { tryGetStoredSession } from './triplaUID'
import userSync from 'javascript/helpers/userSync'
import { useUserStore } from 'Store/user'
import { useAppStore } from 'Store/app'
import { useSettingsStore } from 'Store/settings'
import { useIconMessageStore } from 'Store/icon-message'
import { useCookieConsentStore } from 'Store/cookie-consent'
import { triplaServer } from 'src/apis/server'
import { setTriplaUID } from 'Utilities/triplaUID'
import { SessionStorageKeys } from 'javascript/Constants'

export default async function callAnonymousSignIn(settings, lineIdToken) {
  // await tryGetStoredSession()
  const userStore = useUserStore()
  const appStore = useAppStore()
  const settingsStore = useSettingsStore()
  const iconMessageStore = useIconMessageStore()
  const cookieConsentStore = useCookieConsentStore()

  const url = new URL(window.location)
  const bypassToken = url.searchParams.get('bypass_token')
  const loginToken = url.searchParams.get('tripla_login_token')
  const confirmationToken = url.searchParams.get('confirmation_token')
  const isFirstPartyAnonymousSignIn =
    settingsStore.isFirstPartyDomainEnable &&
    triplaServer.defaults.baseURL.includes(settingsStore.getFirstPartyDomainSetting?.domain_name)

  const { hotel_id: hotelId, facility_sign_in_enabled: facilitySignInEnabled } = settings
  return User.SignIn(
    {
      ...settingsStore.anonymousSignInDataAttributes,
      data_attributes: JSON.stringify(settingsStore.scriptDataAttributes),
      bypass_token: bypassToken || undefined,
      tripla_login_token: loginToken || undefined,
      confirmation_token: confirmationToken || undefined,
      hotel_id: hotelId,
      line_id_token: lineIdToken || undefined,
      provider: window.__tripla_guide_website__ ? 'guide' : 'triplabot'
    },
    {
      withCredentials: isFirstPartyAnonymousSignIn && cookieConsentStore.isAdvertisingCookieEnabled
    }
  ).then((response) => {
    const isFirstPartyAnonymousSignIn =
      settingsStore.isFirstPartyDomainEnable &&
      response.config.baseURL.includes(settingsStore.getFirstPartyDomainSetting?.domain_name)

    const triplaUID = response.headers['tripla-uid']
    if (
      isFirstPartyAnonymousSignIn &&
      triplaUID &&
      !cookieConsentStore.isCookiePreferencesConfirmed
    ) {
      // we'll set this temp_tripla_uid to client_tripla_uid in Cookies later if the user accepts Targeting and Advertising cookie
      sessionStorage.setItem(SessionStorageKeys.TEMP_TRIPLA_UID, triplaUID)
    }

    if (isFirstPartyAnonymousSignIn && cookieConsentStore.isAdvertisingCookieEnabled) {
      setTriplaUID(triplaUID)
    }

    const json = response.data
    const user = json.data.user || {}

    appStore.setSession(json.data.session)
    if (json.data.user.known_user_signed_in) {
      // this local storage is used by gtag only
      localStorage.setItem('triplabot_known_user_signed_in', true)
    }
    localStorage.setItem('triplabot_user_id', json.data.user.id)
    const chatbotActive = settings.active || settingsStore.isCustomBotTestMode
    if (chatbotActive) {
      Vue.rollbar.configure({
        payload: {
          person: { id: json.data.user.id }
        }
      })
      userStore.setUser(json.data.user)
      iconMessageStore.fetchCDPIconMessages()
    }
    if (facilitySignInEnabled) {
      localStorage.setItem('triplabot_auth', 'triplapbot_membership')
    } else {
      localStorage.setItem('triplabot_auth', 'triplabot_sign_in')
      if (chatbotActive && json.data && json.data.user.known_user_signed_in) {
        // set the anonymous user ID so that we can track in Matomo
        userStore.setUser({ ...userStore.user, id: json.data.user.id })
      }
    }
    Vue.prototype.$gtag.recordPageview()

    if (userSync.pubnub) {
      userSync.setState(json.data)
      userSync.unsubscribe()
    }

    if (settingsStore.isBWOpenInNewTab) {
      userSync.initialize(json.data.user)
      userSync.subscribe()
    }

    if (settingsStore.isCookieConsentEnabled && user.cookie_consent_preference?.persisted) {
      const cookiePreferences = { ...user.cookie_consent_preference }
      if (user.known_user_signed_in) {
        cookiePreferences.confirmed = true
      }

      cookieConsentStore.setCookiePreferences(cookiePreferences)
    }

    return json
  })
}
